import { createRequestInstance } from 'services'
import { RawRegistration } from 'types'

export const REGISTRATIONS_URL =
  import.meta.env.VITE_REGISTRATIONS_API_URL || ''

const request = createRequestInstance({
  baseURL: REGISTRATIONS_URL,
})

export async function getRegistrations(
  userId: number,
): Promise<RawRegistration[]> {
  const response = await request.get('', {
    params: {
      detail: 'full',
      user_id: userId,
    },
  })

  return response.data
}
